import { BrowserRouter as Router } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import { Toaster } from "react-hot-toast";
import "./App.css";
import AppLayout from "./components/layout/AppLayout";
import { ImageProvider } from "./contexts/ImageContext";
import { clerkAppearance, clerkLocalization } from "./config/app/clerkAppearance";
import { MAINTENANCE_MODE_ENABLED } from "./config/app/maintenanceMode";
import StayTuned from "./pages/maintenance/StayTuned";
import { appToastOptions } from "./utils/appToast";

function App() {
  if (MAINTENANCE_MODE_ENABLED) {
    return <StayTuned />;
  }

  // Get Clerk publishable key from environment variables
  const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

  return (
    <ClerkProvider
      publishableKey={clerkPublishableKey}
      appearance={clerkAppearance}
      localization={clerkLocalization}
      afterSignOutUrl="/login"
      signInUrl="/login"
      signUpUrl="/login"
    >
      <ImageProvider>
        <Router>
          <AppLayout />
          <Toaster
            position="top-center"
            toastOptions={appToastOptions}
            containerStyle={{ zIndex: 10100 }}
          />
        </Router>
      </ImageProvider>
    </ClerkProvider>
  );
}

export default App;
